import { useStyle } from "./style";
import { FormInput } from "@/components/form-inputs/form-input";
import { IInput } from "@/components/form-inputs/interfaces";
import { accountingInputs } from "../../inputs/accounting-inputs";
import { useTranslation } from "react-i18next";
import { CLIENT_TYPE, CUSTOMER_ACTIONS } from "@/pages/customers/enums";
import { useEffect } from "react";
import type { CustomerRequiredFieldRules } from "@/utils/customer-required-fields";

import type { PaymentTermItem } from "@/services/api-service/customers/payment-terms-api";

interface IProps {
  clientType: string;
  onChangeInputs: (key: any, value: any) => void;
  state: any;
  defaultPaymentTerm?: string | boolean | undefined;
  isAddAction: boolean;
  customerRequiredFieldRules: CustomerRequiredFieldRules;
  paymentTerms?: PaymentTermItem[];
}

const AccountingTab = ({
  clientType,
  onChangeInputs,
  state,
  defaultPaymentTerm,
  isAddAction,
  customerRequiredFieldRules,
  paymentTerms = [],
}: IProps) => {
  const { classes } = useStyle();
  const { t } = useTranslation();
  const isSupplier = clientType === CLIENT_TYPE.SUPPLIER;

  useEffect(() => {
    if (
      !state?.termOfPayment &&
      defaultPaymentTerm !== undefined &&
      !isSupplier &&
      isAddAction
    ) {
      onChangeInputs("termOfPayment", Number(defaultPaymentTerm));
    }
  }, [defaultPaymentTerm, state?.termOfPayment]);

  return (
    <div style={classes.customerInfoStyle}>
      <div style={classes.testSTYLE}>
        {accountingInputs(state, isSupplier, t, customerRequiredFieldRules, paymentTerms)
          .slice(0, 4)
          .map((item) => (
            <FormInput
              input={item as IInput}
              changeState={onChangeInputs}
              error={item.required && !item.value}
              readonly={false}
            />
          ))}
      </div>
      <div style={classes.testSTYLE}>
        {accountingInputs(state, isSupplier, t, customerRequiredFieldRules, paymentTerms)
          .slice(4, 8)
          .map((item) => (
            <FormInput
              input={item as IInput}
              changeState={onChangeInputs}
              error={item.required && !item.value}
              readonly={false}
            />
          ))}
      </div>
    </div>
  );
};

export { AccountingTab };
